export const MOBILE_CHAT = 'MOBILE_CHAT';
